import React from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
/** import mui components in the section above, keep the ascending order */

const useStyles = makeStyles(theme => ({
    warningRoot: {
        backgroundColor: '#fdf0e6',
        padding: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'absolute',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        zIndex: 10,
        boxShadow: theme.shadows[3],
        width: `calc(33.3333% - ${theme.spacing(4)})`,
    },
    warningMessageContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    warningIcon: {
        color: '#5f2b11', // Warning color
        marginRight: theme.spacing(1),
    },
    warningCopyButton: {
        textTransform: 'none',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        color: '#5f2b11',
    },
    messageText: {
        color: '#5f2b11',
    },
    actionsContainer: {
        display: 'flex',
        alignItems: 'center',
    },
}));

const ImportWarning = ({ ids, onClose }) => {
    const classes = useStyles();

    if (!ids || ids.length === 0) return null;

    const copyList = () => {
        const textToCopy = ids.join('\n');
        navigator.clipboard.writeText(textToCopy);
        if (onClose) {
            onClose();
        }
    };

    let message = '';
    if (ids.length === 1) {
        message = `${ids[0]} is not found in the system.`;
    } else if (ids.length === 2) {
        message = `${ids[0]}, ${ids[1]} are not found in the system.`;
    } else {
        message = `${ids[0]}, ${ids[1]} and more are not found in the system.`;
    }

    return (
        <Paper className={classes.warningRoot} elevation={0}>
            <div className={classes.warningMessageContainer}>
                <WarningAmberIcon className={classes.warningIcon} />
                <Typography variant="body2" className={classes.messageText}>
                    {message}
                </Typography>
            </div>
            <div className={classes.actionsContainer}>
                <Tooltip title="Copies missing IDs to clipboard and closes warning">
                    <Button size="small" onClick={copyList} className={classes.warningCopyButton}>
                        Copy List
                    </Button>
                </Tooltip>
            </div>
        </Paper>
    );
};

export default ImportWarning;
